$('.site-header__content--search').each(function () {
    const $this = $(this);

    $this.find('form input').focus(function () {
        $this.addClass('active');
    }).blur(function () {
        $this.removeClass('active');
    });
});
